export default __webpack_public_path__ + "static/media/31c5860c-aba6-4531-ade5-1cf6f23ac71b.081e8122.woff";